import React from "react";
import Spacing from "../Spacing";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import { Link } from "react-router-dom";
import { pageTitle } from "../../helpers/PageTitle";
import { Formik } from "formik";
import FormikInput from "../formik-components/formik-input";
import FormikCheckbox from "../formik-components/form-checkbox";
import * as Yup from "yup";
import Common from "../../helpers/common";

const signinSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    // .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    // .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    // .matches(/[0-9]/, 'Password must contain at least one number')
    // .matches(/[!@#$%^&*]/, 'Password must contain at least one special character')
    .required("Password is required"),
});

export default function SigninSignup() {
  pageTitle("Login | Register");

  const _handleSignup = (values) => {
    console.log("Signup form submitted:", values);
  };
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Login | Register"
        subTitle="Welcome"
        variant="text-center"
        href="/#"
      />
      <Spacing lg="75" md="60" />
      <Formik
        validationSchema={signinSchema}
        initialValues={{
          email: "",
          password: "",
          rememberMe: false,
        }}
      >
        {(formikProps) => (
          <div className="container">
            <div className="row position-relative">
              {/* Login Form */}
              <div
                className="col-12 col-xl-5"
                style={{
                  borderRight: "1px dashed #577c8e",
                  flex: "0 0 auto",
                  width: "41.66666667%",
                }}
              >
                <h2 className="cs_checkout-title">Login</h2>
                <Spacing lg="40" md="40" />
                <div className="row">
                  <div className="col-lg-12">
                    <label className="cs_shop-label">
                      Username or email address *
                    </label>
                    <FormikInput
                      name="email"
                      type="text"
                      className="cs_shop-input"
                      autoComplete="off"
                      formikProps={formikProps}
                    />
                    {/* <input type="text" className="cs_shop-input" autoComplete="off" /> */}
                  </div>
                  <div className="col-lg-12">
                    <label className="cs_shop-label">Password *</label>
                    <FormikInput
                      name="password"
                      type="password"
                      className="cs_shop-input"
                      autoComplete="off"
                      formikProps={formikProps}
                    />
                    {/* <input type="password" className="cs_shop-input" autoComplete="off" /> */}
                  </div>
                  <div className="col-lg-12">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="rememberMe"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="rememberMe"
                        >
                          Remember me
                        </label>
                      </div>
                      <Link to="/forgot-password">Forgot Password?</Link>
                    </div>
                  </div>
                  <div className="col-lg-12 mt-4">
                    <button
                      type="submit"
                      className="cs_product_btn cs_semi_bold w-100"
                      onClick={formikProps.handleSubmit}
                    >
                      LOGIN
                    </button>
                  </div>
                </div>
              </div>

              {/* Register Form */}
              <div className="col-12 col-xl-6 offset-xl-1">
                <h2 className="cs_checkout-title">Register</h2>
                <Spacing lg="40" md="40" />
                <Formik
                  initialValues={{
                    firstName: "",
                    lastName: "",
                    email: "",
                    password: "",
                    termsAccepted: false,
                  }}
                  validationSchema={Yup.object().shape({
                    firstName: Yup.string().required("First name is required"),
                    lastName: Yup.string().required("Last name is required"),
                    email: Yup.string()
                      .email("Invalid email address")
                      .required("Email is required"),
                    password: Yup.string()
                      .min(8, "Password must be at least 8 characters")
                      .required("Password is required"),
                    termsAccepted: Yup.boolean().oneOf(
                      [true],
                      "You must accept the terms and conditions"
                    ),
                  })}
                  onSubmit={(values) => {
                    console.log("Signup form submitted:", values);
                    // Add your signup logic here
                  }}
                >
                  
                  {(formikProps) => (
                    <div className="row">
                      <div className="col-lg-6">
                        <label className="cs_shop-label">First Name *</label>
                        <FormikInput
                          name="firstName"
                          type="text"
                          className="cs_shop-input"
                          formikProps={formikProps}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="cs_shop-label">Last Name *</label>
                        <FormikInput
                          name="lastName"
                          type="text"
                          className="cs_shop-input"
                          formikProps={formikProps}
                        />
                      </div>
                      <div className="col-lg-12">
                        <label className="cs_shop-label">Email address *</label>
                        <FormikInput
                          name="email"
                          type="email"
                          className="cs_shop-input"
                          formikProps={formikProps}
                        />
                      </div>
                      <div className="col-lg-12">
                        <label className="cs_shop-label">Password *</label>
                        <FormikInput
                          name="password"
                          type="password"
                          className="cs_shop-input"
                          formikProps={formikProps}
                        />
                      </div>
                      <div className="col-lg-12">
                        <div className="form-check">
                          <FormikCheckbox
                            name="termsAccepted"
                            formikProps={formikProps}
                            className="form-check-input"
                            text="I agree to the Terms and Conditions"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 mt-4">
                        <button
                          type="submit"
                          className="cs_product_btn cs_semi_bold w-100"
                          onClick={formikProps.handleSubmit}
                        >
                          REGISTER
                        </button>
                      </div>
                    </div>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        )}
      </Formik>
      <Spacing lg="120" md="50" />
    </>
  );
}
